import { TOPIC_VOLUMES } from "../../actions/action-types"
import { PENDING, FULFILLED, REJECTED } from "redux-promise-middleware"

const defaultState = {
    data: [],
    isFulfilled: false,
    isPending: false
}

export default (state = defaultState, action) => {
    switch (action.type) {
        case `${TOPIC_VOLUMES}_${FULFILLED}`:
            return {
                data: state.data
                    // Filter out duplicate topic volumes
                    .filter(
                        d =>
                            d.meta.id !== action.meta.id ||
                            d.meta.startDate !== action.meta.startDate ||
                            d.meta.moderationState !==
                                action.meta.moderationState
                    )
                    .concat([
                        {
                            meta: action.meta,
                            payload: action.payload
                        }
                    ]),
                isFulfilled: true,
                isPending: false
            }

        case `${TOPIC_VOLUMES}_${PENDING}`:
            return {
                data: state.data,
                isFulfilled: false,
                isPending: true
            }

        case `${TOPIC_VOLUMES}_${REJECTED}`:
            return {
                data: [],
                isFulfilled: false,
                isPending: false,
                isRejected: true
            }

        default:
            return state
    }
}
